// src/app/auth-guard/auth-guard.ts

import { CanActivateFn, Router } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core'; // <-- Import PLATFORM_ID
import { isPlatformBrowser } from '@angular/common'; // <-- Import isPlatformBrowser

export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID); // <-- Inject PLATFORM_ID

  // Check if the current environment is a web browser
  const isBrowser = isPlatformBrowser(platformId);

  let isAuthenticated = false;

  if (isBrowser) {
    // ONLY access sessionStorage if we are in the browser
    const token: string | null = sessionStorage.getItem('access_token');

    if (token) {
      console.log('token found');
      isAuthenticated = true;
    } else {
      console.log('token not there');
    }
  }
  // NOTE for SSR: If not in the browser, treat as unauthenticated
  // for the initial server render to prevent rendering protected content.

  if (isAuthenticated) {
    return true;
  } else {
    // Only navigate if we are in the browser,
    // to avoid potential server-side navigation issues.
    if (isBrowser) {
      router.navigateByUrl('/login');
    }
    return false;
  }
};
